module.exports = __webpack_public_path__ + "static/2front-spirit-2-961f553d51d2ff9b9695063ce26c7f56.png";